export const ACCOUNT_ID = "account_id";
export const PLAN_ID = "plan_id";
export const EMAIL_FOR_SIGN_IN = "email_for_sign_in";
export const REDIRECT_URL = "redirect_url";
